export default __webpack_public_path__ + "static/media/helpdesk.a4d99abd.jpg";